import React, { useState, useEffect, useRef } from 'react';
import Dialog from 'components/Dialog';
import NationalNoticeService from 'services/NationalNoticeService';
import Button from 'components/Button';
import Tr from 'translations/Translations';
function BzpNoticeDialog({ id, open, onClose, resultNoticeId }) {
    const [htmlContent, setHtmlContent] = useState('');
    const [loading, setLoading] = useState(false);
    const iframeRef = useRef(null);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = resultNoticeId
                    ? await NationalNoticeService.getTenderResultNoticeContent(id, resultNoticeId)
                    : await NationalNoticeService.getBzpNoticeContent(id);
                setHtmlContent(response.result?.content);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };

        if (open && id) {
            fetchData();
        }
    }, [open, id, resultNoticeId]);



    const handleClose = () => {
        onClose();
        setHtmlContent('');
    };

    const handlePrint = () => {
        if (iframeRef.current) {
            iframeRef.current.contentWindow.print();
        }
    };

    return (
        <Dialog open={open} loading={loading} onClose={handleClose} title={resultNoticeId ? Tr("bzp_tender_result_notice") : Tr("bzp_notice")} maxWidth="lg">
            <div style={{ textAlign: 'right' }}><Button onClick={handlePrint}>{Tr("bzp_notice_print")}</Button> </div>

            <iframe
                ref={iframeRef}
                srcDoc={htmlContent}
                style={{
                    width: '100%',
                    minHeight: '70vh',
                    border: 'none'
                }}
                title='BZP Notice'
            />
        </Dialog>
    );
}

export default BzpNoticeDialog;